import { Component } from "@angular/core";
import {
  NbDialogService,
  NbMenuService,
  NbSidebarService,
  NbThemeService
} from "@nebular/theme";

import { Router } from "@angular/router";
const redirectUri = `${window.location.origin}`;

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent {
  constructor(
    private themeService: NbThemeService,

    private nbMenuService: NbMenuService,
    private sidebarService: NbSidebarService,
    private dialogService: NbDialogService,

    private router: Router
  ) {}

  async ngOnInit() {}
  async logout() {
    if (confirm("Are you sure you want to log out?")) {
    }
  }

  goPage() {
    this.router.navigate(["/dashboard/home"]);
  }
}
